module.exports = __webpack_public_path__ + "assets_app/img/playknop-dropshadow.464b695b.svg";